import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export interface MonthlyRecognitionRow {
  /** `YYYY-MM`. */
  month: string;
  recognized: number;
  scheduled: number;
}

export interface RevenueRecognitionSummary {
  /** Currency every headline figure is denominated in. */
  currency: string;
  deferredBalance: number;
  totalContracted: number;
  totalRecognized: number;
  openScheduleCount: number;
  failedEntryCount: number;
  months: MonthlyRecognitionRow[];
  /** Balances held in another currency — never folded into the headline. */
  otherCurrencies: { currency: string; deferredBalance: number }[];
}

/** NOT-596 — deferred plan revenue: what the shop still owes as service. */
export function useRevenueRecognitionSummary(months = 12) {
  return useApiQuery<RevenueRecognitionSummary>({
    queryKey: [...settingsKeys.revenueRecognition(), 'summary', months],
    queryFn: () =>
      apiGet<RevenueRecognitionSummary>(
        operationsClient,
        `${settingsEndpoints.revenueRecognitionSummary()}?months=${months}`,
      ),
    staleTime: 60_000,
  });
}
